var moduleMap = {
	"./recoil": () => {
		return Promise.all([__webpack_require__.e(178), __webpack_require__.e(73), __webpack_require__.e(257)]).then(() => (() => ((__webpack_require__(9257)))));
	},
	"./services": () => {
		return Promise.all([__webpack_require__.e(660), __webpack_require__.e(323), __webpack_require__.e(178), __webpack_require__.e(88), __webpack_require__.e(403), __webpack_require__.e(582)]).then(() => (() => ((__webpack_require__(2582)))));
	},
	"./login-page": () => {
		return Promise.all([__webpack_require__.e(660), __webpack_require__.e(323), __webpack_require__.e(483), __webpack_require__.e(68), __webpack_require__.e(927), __webpack_require__.e(178), __webpack_require__.e(73), __webpack_require__.e(88), __webpack_require__.e(403), __webpack_require__.e(949), __webpack_require__.e(123), __webpack_require__.e(746), __webpack_require__.e(397), __webpack_require__.e(869), __webpack_require__.e(676)]).then(() => (() => ((__webpack_require__(2676)))));
	},
	"./forget-password-page": () => {
		return Promise.all([__webpack_require__.e(660), __webpack_require__.e(323), __webpack_require__.e(483), __webpack_require__.e(68), __webpack_require__.e(927), __webpack_require__.e(178), __webpack_require__.e(73), __webpack_require__.e(88), __webpack_require__.e(403), __webpack_require__.e(949), __webpack_require__.e(123), __webpack_require__.e(746), __webpack_require__.e(869), __webpack_require__.e(259)]).then(() => (() => ((__webpack_require__(5259)))));
	},
	"./reset-password-page": () => {
		return Promise.all([__webpack_require__.e(660), __webpack_require__.e(323), __webpack_require__.e(483), __webpack_require__.e(927), __webpack_require__.e(178), __webpack_require__.e(73), __webpack_require__.e(88), __webpack_require__.e(403), __webpack_require__.e(949), __webpack_require__.e(123), __webpack_require__.e(746), __webpack_require__.e(397), __webpack_require__.e(27)]).then(() => (() => ((__webpack_require__(2027)))));
	},
	"./resend-verify-email-page": () => {
		return Promise.all([__webpack_require__.e(660), __webpack_require__.e(323), __webpack_require__.e(483), __webpack_require__.e(927), __webpack_require__.e(178), __webpack_require__.e(73), __webpack_require__.e(88), __webpack_require__.e(403), __webpack_require__.e(949), __webpack_require__.e(123), __webpack_require__.e(746), __webpack_require__.e(488)]).then(() => (() => ((__webpack_require__(3488)))));
	},
	"./verify-email-page": () => {
		return Promise.all([__webpack_require__.e(660), __webpack_require__.e(323), __webpack_require__.e(483), __webpack_require__.e(927), __webpack_require__.e(178), __webpack_require__.e(73), __webpack_require__.e(88), __webpack_require__.e(403), __webpack_require__.e(949), __webpack_require__.e(123), __webpack_require__.e(397), __webpack_require__.e(834)]).then(() => (() => ((__webpack_require__(5834)))));
	},
	"./en/translation": () => {
		return __webpack_require__.e(447).then(() => (() => ((__webpack_require__(2447)))));
	},
	"./ms/translation": () => {
		return __webpack_require__.e(164).then(() => (() => ((__webpack_require__(5164)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var oldScope = __webpack_require__.S["default"];
	var name = "default"
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});